<form
  class="field-dialog__content__scroll p-24 forms"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  name="form"
  fusePerfectScrollbar
>
  <div
    *ngIf="segmentMaintenanceFormsArray && segmentMaintenanceFormsArray.controls.length"
    class="forms__header"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <span class="forms__header title" fxFlex="100">
      {{ 'SEGMENTS.DIALOG.FORMS.LINKED_FORMS' | translate }}
    </span>
  </div>

  <div class="forms__body" *ngIf="segmentMaintenanceFormsArray && segmentMaintenanceFormsArray.controls.length">
    <div
      class="forms__body item"
      *ngFor="let segmentMaintenanceFormControl of segmentMaintenanceFormsArray.controls; index as formIndex"
      fxLayout="column"
    >
      <span class="item__position">{{ formIndex + 1 }}º</span>
      <div class="item__wrapper" fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
        <div class="card item__wrapper__card" fxLayout="column" fxFlex>
          <div fxLayout="column" fxFlex="50">
            <forms-input
              class="input"
              required
              appearance="legacy"
              [formControl]="segmentMaintenanceFormControl.get('form')"
              floatLabel="false"
              [disabled]="isViewMode"
            >
            </forms-input>
          </div>

          <div class="item__wrapper__card__input" fxLayout="row" fxFlex="50">
            <fc-maintenance-type-input
              [displayText]="segmentMaintenanceFormControl.get('maintenanceType')?.get('name')?.value"
              [control]="segmentMaintenanceFormControl.get('maintenanceType')"
              [isDuplicatedForm]="isDuplicatedForm"
              [legacyStyle]="true"
              [preloadOptions]="true"
              [requiredMark]="true"
              [showAllMaintenanceTypesOption]="true"
              [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
              [selectedSegment]="selectedSegment"
            ></fc-maintenance-type-input>

            <div class="item__wrapper checkboxes" fxFlex="30" fxLayoutAlign="space-between">
              <div class="checkboxes__item" fxLayout="row" fxFlex="33">
                <img
                  class="checkboxes__icon"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_START' | translate }}"
                  src="assets/images/icons/icon-lock-clock.svg"
                />
                <mat-checkbox
                  [disabled]="isViewMode"
                  class="checkboxes__checkbox"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_START' | translate }}"
                  [formControl]="segmentMaintenanceFormControl.get('requiredStart')"
                ></mat-checkbox>
              </div>
              <div class="checkboxes__item" fxLayout="row" fxFlex="33">
                <img
                  class="checkboxes__icon"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_COMPLETE' | translate }}"
                  src="assets/images/icons/icon-check-circle.svg"
                />
                <mat-checkbox
                  [disabled]="isViewMode"
                  class="checkboxes__checkbox"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_COMPLETE' | translate }}"
                  [formControl]="segmentMaintenanceFormControl.get('requiredComplete')"
                ></mat-checkbox>
              </div>
              <div class="checkboxes__item" fxLayout="row" fxFlex="33">
                <img
                  class="checkboxes__icon"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_REPORT' | translate }}"
                  src="assets/images/icons/icon-warning.svg"
                />
                <mat-checkbox
                  [disabled]="isViewMode"
                  class="checkboxes__checkbox"
                  matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REQUIRED_REPORT' | translate }}"
                  [formControl]="segmentMaintenanceFormControl.get('requiredReport')"
                ></mat-checkbox>
              </div>
            </div>
          </div>

          <mat-error
            class="item__wrapper error"
            *ngIf="segmentMaintenanceFormControl.get('form').hasError('formDuplicated')"
          >
            {{ 'SEGMENTS.DIALOG.FORMS.DUPLICATED_FORMS' | translate }}
          </mat-error>
        </div>

        <div *ngIf="!isViewMode" class="item__remove" fxFlex="10">
          <button
            matTooltip="{{ 'SEGMENTS.DIALOG.FORMS.REMOVE' | translate }}"
            mat-icon-button
            (click)="removeForm(formIndex)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="forms__body"
    *ngIf="!segmentMaintenanceFormsArray.controls.length"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="p-24"
  >
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="no-forms">assignment</mat-icon>
    </p>
    <span class="h3">
      {{ 'SEGMENTS.DIALOG.FORMS.WITHOUT_FORMS' | translate }}
    </span>
  </div>

  <div *ngIf="!isViewMode" class="forms__footer" (click)="addForm()" matRipple>
    <div fxLayout="column" fxLayoutAlign="center center">
      <span role="button" class="message-upload" for="getFile">
        {{ 'SEGMENTS.DIALOG.FORMS.ADD_FORM' | translate }}
      </span>
    </div>
  </div>
</form>
